/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */
/* eslint-disable import/no-cycle */
import { toolsList } from '../templates/constants';

export const checkIfTools = (template) => toolsList.templates.map((tool) => tool.code).includes(template);
